<div *ngIf="footer | async as footer" class="surveys-element-footer">
    <surveys-element-html *ngIf="hasFooter(footer)" [element]="{data: footer}"> </surveys-element-html>
</div>